import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { FieldInput } from "@/components/FieldInput";
import { api, errMsg, inr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useMasters } from "@/hooks/useMasters";

export function LinkDialog({ row, onClose }) {
  const masters = useMasters();
  const { bump } = useAuth();
  const transfer = row.transaction_type === "Transfer";
  const [v, setV] = useState({ payment_mode: row.payment_mode || "UPI", fund_account_id: row._fund_account_id || "", reference_no: row.reference_no || "", transaction_time: row.transaction_time || "" });
  const [busy, setBusy] = useState(false);
  const fields = [
    { name: "payment_mode", label: "Payment Mode", type: "select", options: ["Cash", "UPI", "Bank Transfer", "Other"], required: true },
    { name: "fund_account_id", label: "Bank Account / UPI ID", type: "fund", required: true,
      types: (x) => (transfer || x.payment_mode === "Other" ? null : x.payment_mode === "Cash" ? ["Cash"] : ["Bank", "UPI"]) },
    { name: "reference_no", label: "Transaction ID / UTR No.", type: "text" },
    { name: "transaction_time", label: "Time", type: "time" },
  ];
  const save = async () => {
    if (!v.fund_account_id) return toast.error("Select account");
    setBusy(true);
    try {
      await api.post(`/cash/${row._txn}/link`, v);
      toast.success("Account linked");
      bump();
      onClose();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="link-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">Link Bank/UPI — {row._txn}</DialogTitle>
          <DialogDescription className="text-xs">
            {row.transaction_type} · {inr(row.receipt || row.payment)} · Purani entry ko sahi bank account / UPI ID se jodein. Change audit log mein record hoga.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-3">
          {fields.map((f) => (
            <FieldInput key={f.name} f={f} value={v[f.name]} values={v} masters={masters} testPrefix="link"
              onChange={(x) => setV((s) => ({ ...s, [f.name]: x, ...(f.name === "payment_mode" ? { fund_account_id: "" } : {}) }))} />
          ))}
        </div>
        <DialogFooter><Button onClick={save} disabled={busy} data-testid="link-save-btn">{busy ? "Saving..." : "Save link"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
